import { cn } from '@/lib/utils'
import * as React from 'react'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	rightSection?: React.ReactNode
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, rightSection, ...props }, ref) => {
	return (
		<div className="relative flex items-center w-full">
			<input
				className={cn(
					'flex h-10 w-full rounded-xl border px-3 py-2 text-sm placeholder:text-[#918e8e] focus:outline-none disabled:cursor-not-allowed disabled:opacity-50',
					rightSection && 'pr-10',
					className,
				)}
				ref={ref}
				type={type}
				{...props}
			/>
			{rightSection && <div className="absolute right-3 top-1/2 -translate-y-1/2">{rightSection}</div>}
		</div>
	)
})
Input.displayName = 'Input'

export { Input }
